module.exports = __webpack_public_path__ + "static/media/44493360_2199896583418854_7071552228527439872_o-thumb.bfd931f7.jpg";